"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingStatusBadge = BillingStatusBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var table_1 = require("../table");
function BillingStatusBadge(props) {
    var _a;
    var status = props.status;
    var BADGES = {
        active: { label: "Active", color: "green-soft" },
        trialing: { label: "Trial", color: "blue" },
        past_due: { label: "Past due", color: "amber" },
        unpaid: { label: "Suspended", color: "red" },
        canceled: { label: "Canceled", color: "gray" },
        incomplete_expired: { label: "Canceled", color: "gray" },
    };
    var badge = (_a = BADGES[status]) !== null && _a !== void 0 ? _a : { label: status, color: "gray" };
    return (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: badge.color, children: badge.label });
}
